import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import Animate from '../../../components/Animate';
import dataModel from '../../../models/DataModel';
import { project_root } from '../../../dao/ProjectsDAO';
import './ProjectAddCard.scss';
import Input from '../../Input';

class ProjectAddCard extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = { projectName: '' };
  }

  componentDidMount() {
    super.componentDidMount();
    if (this.inputField) {
      this.inputField.focus();
    }
  }

  handleAddProject() {
    if (this.state.projectName) {
      const newProject = { name: this.state.projectName, notes: '', company_id: this.props.currentCompany.id, custom_project_settings: [], location: { name: '', guid: '', address: '', city: '', state: '', zip: '', latitude: '', longitude: '' } };
      dataModel.projectsDAO.createProject(newProject, { recordDescriptor: project_root }).then(createdProject => {
        this.props.handleProjectAdd(createdProject);
      });
      this.handleCancel();
    }
    else {
      dataModel.displayInfoErrorMessage(this.textMap.projectNameRequired, 4000, 2);
    }
  }

  handleCancel() {
    this.setState({ cancelAdd: true });
  }

  handleCloseAnimation() {
    if (this.props.closeAddCard) {
      this.props.closeAddCard();
    }
  }

  handleChange(e) {
    this.setState({ projectName: e.target.value });
  }

  handleKeyDown(e) {
    if (e.keyCode == 13 || e.keyCode == 40) {
      this.handleAddProject();
    }
    else if (e.keyCode == 27) {
      this.handleCancel();
    }
  }

  handleValidation(string){
    let pass = false;
    if (string && string.length > 0 && string.trim() != ''){
      pass = true;
    }
    return pass;
  }

  render() {
    let style = {
      width: 246,
    };

    return (

      // Replace with the appropriate HTML
      <div className={'project-add-card'} id={this.props.id} style={style}>
        <Animate key="animate-card-in" component_id={this.props.id} duration={250} property={{
          height: {
            startVal: 0,
            endVal: 100,
          },
        }} onUnmount={false} /> 
        {this.state.cancelAdd && (
          <Animate key="animate-card-out" component_id={this.props.id} duration={250} property={{
            height: {
              startVal: 100,
              endVal: 0,
            },
          }} onUnmount={false} completionCallback={this.handleCloseAnimation} /> 
        )}
        <div className="add-project-box">
          <Input className="project-input" value={this.state.projectName} onChange={this.handleChange}
            placeholder={this.textMap.newProject} onKeyDown={this.handleKeyDown} ref={(element) => {
              this.inputField = element;
            }}/>
        </div>
        <div className="add-button" onClick={this.handleAddProject}><span className="add-text">{this.textMap.add.toUpperCase()}</span></div>
        <div className="cancel-button" onClick={this.handleCancel}/>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(ProjectAddCard);



// WEBPACK FOOTER //
// ./src/components/ProjectsNav/ProjectAddCard/index.js